
import { Enums } from '@bode-canada/core';
import Icon from '@/ui-kit/components/icon';
import Address from '../address';
import { IconType } from '@/ui-kit/components/icon/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import StyleClassNamesBuilder from '@/ui-kit/styles/helpers/StyleClassNamesBuilder';
import regexps from '@/constants/regexps';

export default {
  name: 'InfoComponent',
  components: {
    Icon,
    Address,
  },
  props: {
    listing: {
      type: Object,
      default: () => {},
    },
    isSold: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    IconType,
  }),
  computed: {
    square() {
      const sqft = this.listing.finishedSqft || this.listing.sqFt;
      return sqft
        ? `${sqft.toString().replace(regexps.sqft, ',')} sqft`
        : null;
    },
    isAllInfoExists() {
      const {
        totalBeds,
        totalBaths,
      } = this.listing;
      return totalBeds && totalBaths && this.square;
    },
    isBode() {
      return this.listing.origin === Enums.ListingOriginEnum.BODE;
    },
    infoItemsClassName() {
      return new StyleClassNamesBuilder('info-items__copy')
        .addConditionClassName('white', this.isSold && this.isBode)
        .addConditionClassName('small-space', this.isAllInfoExists)
        .build();
    },
    iconColorScheme() {
      return this.isSold && this.isBode
        ? StyleColorSchemeType.Success
        : StyleColorSchemeType.Secondary;
    },
  },
};
